module.exports = __webpack_public_path__ + "static/media/1017239.5bf06b3d.jpg";